import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ListElementComponent } from './list-element/list-element.component';
import { BadgeComponent } from './badge/badge.component';
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';

@NgModule({
  declarations: [
    ListElementComponent,
    BadgeComponent,
    HorizontalMenuComponent,
  ],
  imports: [CommonModule, RouterModule],
  exports: [
    ListElementComponent,
    BadgeComponent,
    HorizontalMenuComponent
  ]
})

export class SharedModule {

}
